import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "明星资讯", to: "/news" },
  { label: "作品一览", to: "/works" },
  { label: "个人资料", to: "/profile" },
  { label: "粉丝互动", to: "/fan-interaction" },
  { label: "关于本站", to: "/about" },
];

export default function SiteNavbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/news?q=${encodeURIComponent(q)}` : "/news");
    setOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap px-3 py-2 text-sm font-medium rounded-md transition-colors ${
      isActive
        ? "text-primary-600 bg-primary-50"
        : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px] gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
              优
            </span>
            <span className="hidden sm:flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
                大岛优香
              </span>
              <span className="text-[11px] tracking-[0.25em] text-foreground-500">
                YUKA OSHIMA
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={handleSearch}
              className="hidden md:flex items-center bg-background-100 border border-background-200 rounded-full px-3 py-1.5 focus-within:border-primary-300 transition-colors"
            >
              <i className="ri-search-line text-foreground-500 text-sm w-4 h-4 flex items-center justify-center" />
              <input
                type="text"
                name="keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索资讯 / 作品"
                className="bg-transparent border-0 outline-none text-sm text-foreground-800 placeholder:text-foreground-400 w-32 xl:w-44 px-2"
              />
            </form>

            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4 animate-fade-up">
          <form
            onSubmit={handleSearch}
            className="flex items-center bg-background-100 border border-background-200 rounded-full px-3 py-2 mb-3"
          >
            <i className="ri-search-line text-foreground-500 text-sm w-4 h-4 flex items-center justify-center" />
            <input
              type="text"
              name="keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索资讯 / 作品"
              className="bg-transparent border-0 outline-none text-sm text-foreground-800 placeholder:text-foreground-400 flex-1 px-2"
            />
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}